import { useResolvedRoutes } from '@/lib/use-routes';
import { cn } from '@/lib/utils';
import { Link } from '@tanstack/react-router';

export function AppointmentClientLink({
  leadId,
  name,
  onNavigate,
  className,
}: {
  leadId: string;
  name: string;
  onNavigate?: () => void;
  className?: string;
}) {
  const routes = useResolvedRoutes();
  return (
    <Link
      to={routes.customerDetail(leadId)}
      onClick={onNavigate}
      aria-label={`Open client profile for ${name}`}
      className={cn(
        'rounded-sm font-medium underline underline-offset-4 hover:text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
        className
      )}
    >
      {name}
    </Link>
  );
}
